import { render, staticRenderFns } from "./commonMode.vue?vue&type=template&id=ce966b8a&scoped=true&"
import script from "./commonMode.vue?vue&type=script&lang=js&"
export * from "./commonMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce966b8a",
  null
  
)

export default component.exports